(function () {
  if (window.__curlingCartDrawerRecosInit) return;
  window.__curlingCartDrawerRecosInit = true;

  const config = document.currentScript;
  const addToCartLabel = config?.dataset.addToCart || "Add to cart";

  const SECTION_ID_BY_INTENT = {
    related: "related-products",
    complementary: "complementary-products",
  };

  const MAX_ITEMS_PER_BLOCK = 4; // 4 max "Compléter votre look" + 4 max "Autres couleurs"

  const STATE = {
    lastMainProductId: null,
    currency: config?.dataset.currency || "EUR",
    scheduled: null,
    productCache: new Map(), // handle -> product json
  };

  // -----------------------------
  // Helpers
  // -----------------------------
  function getDrawerRoot() {
    return (
      document.querySelector("cart-drawer") ||
      document.querySelector("#cart-drawer") ||
      document.querySelector(".cart-drawer")
    );
  }
  function getMount(intent) {
    const d = getDrawerRoot();
    return d ? d.querySelector(`[data-cart-recos-mount="${intent}"]`) : null;
  }
  function getWrapper(intent) {
    const d = getDrawerRoot();
    return d ? d.querySelector(`[data-cart-recos-wrapper="${intent}"]`) : null;
  }

  async function getCart() {
    const r = await fetch(`${window.curlingStorefrontRoot()}cart.js`, { credentials: "same-origin" });
    if (!r.ok) return null;
    const cart = await r.json();
    STATE.currency = cart.currency || STATE.currency;
    return cart;
  }

  // Produit de référence = plus cher UNITAIRE
  function pickMainProductId(cart) {
    if (!cart?.items?.length) return null;
    const richest = cart.items.reduce((b, i) => {
      const u = i.final_price ?? i.price ?? 0;
      const bu = b.final_price ?? b.price ?? 0;
      return u > bu ? i : b;
    }, cart.items[0]);
    return richest.product_id;
  }

  async function fetchRecoHtml(productId, intent, limit = 8) {
    const base = new URLSearchParams({
      product_id: String(productId),
      limit: String(limit),
      intent,
    });

    const candidates = [
      SECTION_ID_BY_INTENT[intent],
      "related-products",
      "product-recommendations-section",
      "product-recommendations",
      null,
    ].filter((v, i, a) => a.indexOf(v) === i);

    for (const sid of candidates) {
      const url = sid
        ? `${window.curlingStorefrontRoot()}recommendations/products?${base.toString()}&section_id=${encodeURIComponent(sid)}`
        : `${window.curlingStorefrontRoot()}recommendations/products?${base.toString()}`;

      const r = await fetch(url, { credentials: "same-origin" });
      if (!r.ok) continue;

      const html = await r.text();
      if (html && html.length > 200) return html;
    }
    return "";
  }

  function uniqueHandlesFromRecoHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const links = Array.from(
      doc.querySelectorAll('a[href^="/products/"],a[href*="/products/"]')
    )
      .map((a) => a.getAttribute("href") || "")
      .filter(Boolean);

    const handles = [];
    const seen = new Set();
    for (const href of links) {
      const m = href.match(/\/products\/([^\/\?]+)/);
      if (!m) continue;
      const h = m[1];
      if (!seen.has(h)) {
        seen.add(h);
        handles.push(h);
      }
    }
    return handles;
  }

  async function fetchProductJson(handle) {
    if (STATE.productCache.has(handle)) return STATE.productCache.get(handle);
    const r = await fetch(`${window.curlingStorefrontRoot()}products/${handle}.js`, { credentials: "same-origin" });
    if (!r.ok) return null;
    const p = await r.json();
    STATE.productCache.set(handle, p);
    return p;
  }

  function formatMoney(cents) {
    if (typeof cents !== "number") return "";
    return new Intl.NumberFormat(document.documentElement.lang || "fr", { style: "currency", currency: STATE.currency }).format(cents / 100);
  }

  // Prix de référence (compare_at) via variants
  function bestCompareAt(product) {
    const vals = (product.variants || [])
      .map((v) =>
        v && typeof v.compare_at_price === "number" ? v.compare_at_price : null
      )
      .filter((v) => v && v > (product.price || 0));
    return vals.length ? Math.max(...vals) : null;
  }

  function isOnSale(product) {
    const ca = bestCompareAt(product);
    return typeof ca === "number" && ca > (product.price || 0);
  }

  // -----------------------------
  // CSS injecté (affichage recos)
  // - grille 2 colonnes
  // - image entière (contain)
  // - pas de fond gris
  // - contenu centré sous l’image
  // -----------------------------
  function ensureRecoStyles() {
    if (document.querySelector("style[data-cr-reco-style]")) return;

    const css = `
/* Recos grille 2 colonnes dans le cart drawer */
#cart-drawer .cr-list{
  display:grid;
  grid-template-columns:repeat(2,1fr);
  gap:18px;
  margin:0;
  padding:0
}
#cart-drawer .cr-item{
  display:flex;
  flex-direction:column;
  align-items:stretch
}
#cart-drawer .cr-img{
  display:block;
  width:100%;
  padding:0;
  margin:0;
  background:transparent
}
#cart-drawer .cr-img img{
  width:100%;
  height:220px;           /* ajuste la taille visuelle */
  object-fit:contain;     /* ✅ jamais de crop */
  background:transparent; /* ✅ supprime le gris */
  display:block
}
#cart-drawer .cr-info{
  width:100%;
  margin-top:10px;
  text-align:center
}
#cart-drawer .cr-title{
  display:block;
  font-size:12px;
  line-height:1.3;
  text-decoration:none;
  text-align:center
}
#cart-drawer .cr-prices{
  margin-top:8px;
  display:flex;
  gap:10px;
  justify-content:center;
  align-items:baseline
}
#cart-drawer .cr-price{
  font-size:12px;
  color:#111
}
#cart-drawer .cr-price--sale{color:#c00}
#cart-drawer .cr-price--compare{
  color:#111;
  text-decoration:line-through;
  opacity:.7
}
#cart-drawer .cr-action{
  margin-top:10px;
  text-align:center
}
#cart-drawer .cr-atc{
  font-size:12px;
  text-decoration:underline;
  background:none;
  border:0;
  padding:0;
  cursor:pointer
}
    `.trim();

    const style = document.createElement("style");
    style.setAttribute("data-cr-reco-style", "1");
    style.textContent = css;
    document.head.appendChild(style);
  }

  // -----------------------------
  // ✅ Ouvrir le Quick Buy natif Prestige
  // -----------------------------
  function openPrestigeQuickBuy(handle) {
    const hasQuickBuyModal = !!window.customElements?.get?.("quick-buy-modal");

    if (hasQuickBuyModal) {
      let modal = document.querySelector("quick-buy-modal[data-cr-reco-qb]");

      if (!modal) {
        modal = document.createElement("quick-buy-modal");
        modal.setAttribute("data-cr-reco-qb", "1");
        modal.className = "quick-buy-modal modal modal--lg color-scheme color-scheme--dialog";
        document.body.appendChild(modal);
      }

      modal.setAttribute("handle", handle);

      try {
        if (typeof modal.show === "function") return modal.show();
        if (typeof modal.open === "function") return modal.open();
        if (typeof modal.showModal === "function") return modal.showModal();
      } catch (_) {}

      modal.setAttribute("open", "");
      modal.style.display = "block";
      modal.style.opacity = "1";
      return;
    }

    // fallback : PDP
    window.location.href = `${window.curlingStorefrontRoot()}products/${handle}`;
  }

  // -----------------------------
  // Render grille reco (infos dessous)
  // -----------------------------
  function renderRecoCard(product) {
    const url = `${window.curlingStorefrontRoot()}products/${product.handle}`;
    const img = product.featured_image || (product.images && product.images[0]) || "";

    const sale = isOnSale(product);
    const compareAt = bestCompareAt(product);

    const priceHtml = sale
      ? `<div class="cr-prices">
           <span class="cr-price cr-price--sale">${formatMoney(product.price)}</span>
           <span class="cr-price cr-price--compare">${formatMoney(compareAt)}</span>
         </div>`
      : `<div class="cr-prices">
           <span class="cr-price">${formatMoney(product.price)}</span>
         </div>`;

    return `
      <div class="cr-item">
        <a class="cr-img" href="${url}" aria-label="${product.title}">
          ${img ? `<img src="${img}" alt="${product.title}" loading="lazy">` : ``}
        </a>
        <div class="cr-info">
          <a class="cr-title" href="${url}">${product.title}</a>
          ${priceHtml}
          <div class="cr-action">
            <button class="cr-atc" type="button" data-handle="${product.handle}">${addToCartLabel}</button>
          </div>
        </div>
      </div>
    `;
  }

  function bindRecoActions(mountEl) {
    mountEl.querySelectorAll("button.cr-atc[data-handle]").forEach((btn) => {
      if (btn.dataset.bound === "1") return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", () => {
        const handle = btn.getAttribute("data-handle");
        openPrestigeQuickBuy(handle);
      });
    });
  }

  async function renderIntent(intent, productId) {
    const wrapper = getWrapper(intent);
    const mount = getMount(intent);
    if (!wrapper || !mount) return;

    wrapper.style.display = "none";
    mount.innerHTML = "";

    ensureRecoStyles();

    const html = await fetchRecoHtml(productId, intent, 10);
    const handles = uniqueHandlesFromRecoHtml(html).slice(0, MAX_ITEMS_PER_BLOCK);
    if (!handles.length) return;

    const products = (await Promise.all(handles.map(fetchProductJson))).filter(Boolean);
    if (!products.length) return;

    mount.innerHTML = `<div class="cr-list">${products.map(renderRecoCard).join("")}</div>`;
    bindRecoActions(mount);
    wrapper.style.display = "";
  }

  // -----------------------------
  // Refresh logic
  // -----------------------------
  async function refreshAll(force = false) {
    const cart = await getCart();
    const productId = pickMainProductId(cart);
    const d = getDrawerRoot();

    if (!d || !productId) {
      d?.querySelectorAll("[data-cart-recos-wrapper]")?.forEach((w) => (w.style.display = "none"));
      STATE.lastMainProductId = null;
      return;
    }

    const empty = !getMount("related")?.innerHTML || !getMount("complementary")?.innerHTML;
    if (!force && STATE.lastMainProductId === productId && !empty) return;

    STATE.lastMainProductId = productId;

    for (let i = 0; i < 15; i++) {
      if (getMount("related") && getMount("complementary")) break;
      await new Promise((r) => setTimeout(r, 120));
    }

    await Promise.all([renderIntent("related", productId), renderIntent("complementary", productId)]);
  }

  function schedule(delay = 700, force = false) {
    clearTimeout(STATE.scheduled);
    STATE.scheduled = setTimeout(() => refreshAll(force), delay);
  }

  // Hooks cart updates (fetch + XHR)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
      if (url && (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))) {
        schedule(900, true);
      }
    } catch {}
    return res;
  };

  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.__curling_url = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("loadend", () => {
      try {
        const url = String(this.__curling_url || "");
        if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update")) {
          schedule(900, true);
        }
      } catch {}
    });
    return _send.apply(this, arguments);
  };

  // Open drawer
  document.addEventListener("click", (e) => {
    const openCart = e.target.closest('[aria-controls*="cart-drawer"],button[name="open-cart"],a[href="/cart"]');
    if (openCart) schedule(250, true);
  });

  document.addEventListener("DOMContentLoaded", () => schedule(1100, true));
})();
